import { render } from "./ChatDB.vue?vue&type=template&id=00dba7a3&scoped=true"
import script from "./ChatDB.vue?vue&type=script&lang=js"
export * from "./ChatDB.vue?vue&type=script&lang=js"

import "./ChatDB.vue?vue&type=style&index=0&id=00dba7a3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00dba7a3"]])

export default __exports__